import React from 'react';
import { Card, CardContent } from '@/components/ui/card';

const PrivacyPolicyPage = () => {
  return (
    <main className="min-h-screen bg-gradient-to-br from-emerald-50 to-teal-50 py-12">
      <div className="max-w-4xl mx-auto px-4">
        <h1 className="text-4xl font-bold text-gray-900 mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
          Privacy Policy
        </h1>
        <p className="text-gray-600 mb-8">Last updated: January 2026</p>

        <Card>
          <CardContent className="p-8 prose prose-emerald max-w-none">
            <h2>1. Introduction</h2>
            <p>
              Flippy Homes (Pty) Ltd ("we", "our", "us") is committed to protecting your personal information 
              and your right to privacy. This Privacy Policy explains how we collect, use, disclose, and 
              safeguard your information when you visit our website flippyhomes.co.za.
            </p>

            <h2>2. Information We Collect</h2>
            <p>We collect information that you voluntarily provide to us when you:</p>
            <ul>
              <li>Register on our platform</li>
              <li>List a property</li>
              <li>Contact an agent or property owner</li>
              <li>Subscribe to our services</li>
              <li>Contact us for support</li>
            </ul>
            <p>This information may include:</p>
            <ul>
              <li>Name and contact details (email, phone number)</li>
              <li>Identity documents (for verification purposes)</li>
              <li>Property details and images</li>
              <li>Payment information</li>
              <li>Communication preferences</li>
            </ul>

            <h2>3. How We Use Your Information</h2>
            <p>We use your information to:</p>
            <ul>
              <li>Provide and maintain our services</li>
              <li>Process transactions and send related information</li>
              <li>Send promotional communications (with your consent)</li>
              <li>Respond to your inquiries and provide support</li>
              <li>Improve our website and services</li>
              <li>Comply with legal obligations</li>
            </ul>

            <h2>4. Information Sharing</h2>
            <p>
              We do not sell your personal information. We may share your information with:
            </p>
            <ul>
              <li>Other users (e.g., agents can see inquiries from potential buyers)</li>
              <li>Service providers who assist in our operations</li>
              <li>Legal authorities when required by law</li>
            </ul>

            <h2>5. Data Security</h2>
            <p>
              We implement appropriate technical and organizational security measures to protect your 
              personal information. However, no method of transmission over the Internet is 100% secure.
            </p>

            <h2>6. Your Rights (POPIA)</h2>
            <p>Under the Protection of Personal Information Act (POPIA), you have the right to:</p>
            <ul>
              <li>Access your personal information</li>
              <li>Correct inaccurate information</li>
              <li>Request deletion of your information</li>
              <li>Object to processing of your information</li>
              <li>Lodge a complaint with the Information Regulator</li>
            </ul>

            <h2>7. Cookies</h2>
            <p>
              We use cookies and similar tracking technologies to enhance your experience. 
              See our Cookie Policy for more details.
            </p>

            <h2>8. Contact Us</h2>
            <p>
              For privacy-related inquiries, contact us at:<br/>
              Email: privacy@flippyhomes.co.za<br/>
              WhatsApp: +27 65 524 9286
            </p>

            <h2>9. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. We will notify you of any changes 
              by posting the new Privacy Policy on this page and updating the "Last updated" date.
            </p>
          </CardContent>
        </Card>
      </div>
    </main>
  );
};

export default PrivacyPolicyPage;
